import { render, staticRenderFns } from "./CompLoginModal.vue?vue&type=template&id=9a6b4874&scoped=true&"
import script from "./CompLoginModal.vue?vue&type=script&lang=js&"
export * from "./CompLoginModal.vue?vue&type=script&lang=js&"
import style0 from "./CompLoginModal.vue?vue&type=style&index=0&id=9a6b4874&prod&lang=scss&scoped=true&"
import style1 from "./CompLoginModal.vue?vue&type=style&index=1&id=9a6b4874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6b4874",
  null
  
)

export default component.exports